export default {"src":"/_next/static/media/exclusive.67236b62.svg","height":16,"width":16};